import Button from '@shared/components/core/button/CoreButton';
import PageBannerCard from '@shared/components/core/card/PageBannerCard';
import { useTranslation } from 'react-i18next';

interface IOrgNoAccessBannerProps {
    title?: string;
    description?: string;
    children?: React.ReactNode;
}

export default function OrgNoAccessBanner({ title, description, children }: IOrgNoAccessBannerProps) {
    const { t } = useTranslation();

    return (
        <PageBannerCard
            description={description ?? t('common:organization.noAccess.description')}
            fullHeight
            icon="cancel"
            title={title ?? t('common:organization.projects.accessDenied.title')}>
            {children ? (
                children
            ) : (
                <Button href="#" startIcon="back">
                    {t('common:back')}
                </Button>
            )}
        </PageBannerCard>
    );
}
